import { htmlSafe } from '@ember/template';

export function bodyPreview(body) {
  let styledBody = body.replaceAll(
    '{{',
    '<span class="font-medium bg-[#CCFBF1] px-1 py-0.5 rounded-sm" data-test-template-macro>'
  );
  styledBody = styledBody.replaceAll('}}', '</span>');
  return htmlSafe(styledBody);
}
